import { VeraPromptGuideKey, VeraPromptGuideOptions } from './veraPromptGuideShared';
import {
  buildAdminCoachingGuide,
  buildAdminGroundingGuide,
  buildAdminIntentGuide,
  buildAdminFullPipelineGuide,
} from './veraPromptAdminGuides';
import {
  buildGlobalGroundingGuide,
  buildGlobalIntentGuide,
  buildGlobalSystemGuide,
  buildGlobalFullPipelineGuide,
} from './veraPromptGlobalGuides';

export type { VeraPromptGuideKey, VeraPromptGuideOptions } from './veraPromptGuideShared';

export function getVeraPromptContextGuide(
  key: VeraPromptGuideKey,
  options: VeraPromptGuideOptions = {},
): string {
  switch (key) {
    case 'global_system':
      return buildGlobalSystemGuide(options);
    case 'global_intent':
      return buildGlobalIntentGuide(options);
    case 'global_grounding':
      return buildGlobalGroundingGuide(options);
    case 'admin_coaching':
      return buildAdminCoachingGuide();
    case 'admin_intent':
      return buildAdminIntentGuide();
    case 'admin_grounding':
      return buildAdminGroundingGuide();
    default:
      return '';
  }
}

export function getVeraPromptFullPipelineGuide(
  product: 'global' | 'admin',
  options: VeraPromptGuideOptions = {},
): string {
  if (product === 'global') {
    return buildGlobalFullPipelineGuide(options);
  }
  return buildAdminFullPipelineGuide();
}
